import { useNavigate } from 'react-router-dom';
import backSound from "../assets/sounds/back.wav"
import { useRef } from 'react';
const BackButton = ({category}) => {
  const navigate = useNavigate();
  const backSoundObject = useRef(new Audio(backSound))
  const ArrowIcon = () => (
    <svg 
      width="20" 
      height="20" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
  );

  return (
    <>
      {/* Large screen - top right */}
      <button
        onClick={() => {
            backSoundObject.current.currentTime  = 0;
            backSoundObject.current.play();
            navigate("/category/"+category)

        }
        }
        className="hidden lg:fixed lg:flex top-6 right-6 items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg z-50"
      >
        <span className="font-medium">{category}</span>
        <ArrowIcon />
      </button>

      {/* Small screen - bottom fixed */}
      <button
        onClick={() => {
            backSoundObject.current.currentTime  = 0;
            backSoundObject.current.play();
            navigate("/category/"+category)
        }
        }
        className="lg:hidden fixed bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors shadow-lg z-50"
      >
        <span className="font-medium">{category}</span>
        <ArrowIcon />
      </button>
    </>
  );
};

export default BackButton;

